document.addEventListener('DOMContentLoaded', () => {
  // PDP selected variant
  replaceTextUnsafe('.option-selector .cc-select__btn', 'Limited Stock', 'In stock');

  // Cart
  replaceTextUnsafe('.cart-item__variant-value', 'Limited Stock', 'In stock');

  // Pre-order text
  replaceTextUnsafe('.trf-option-preorder-date', 'Limited Stock', 'In stock');
  replaceTextUnsafe('.trf-preorder-text-wrapper', 'Limited Stock', 'In stock');
});

// PDP variant list
$(this).on('variantChanged', function (evt, variant) {
  replaceTextUnsafe('.cc-select__option.js-option span', 'Limited Stock', 'In stock');
});

// Cart drawer
document.addEventListener('theme:open-cart-drawer', () => {
  replaceTextUnsafe('.cart-item__variant-value', 'Limited Stock', 'In stock');
});

/**
 * Replace a substring `textPattern` from the `innerHTML` of all DOM elements matching the `querySelector` with `textReplacement`.
 * Unfortunately, we do not have any other options than changing the `innerHTML` as some of the target DOM elements can contain more HTML elements inside them, so we need to keep them. For example, the preorder text on the product card: `29" (6 bolt) / Boost - Limited stock<br>29" (6 bolt) / SUPER-Boost - Limited stock<br>29" (Centre-lock) / Boost - Limited stock`
 * If no DOM elements matching `querySelector` are found, nothing happens, or no `textPatterns` found in the selected DOM elements, nothing happens.

 * @param {string} querySelector The DOM selector for elements to apply the replacement to.
 * @param {string} textPattern The text to be replaced.
 * @param {string} textReplacement The text to be replaced with.
 * @returns {undefined}
 * @throws {Error} when the `textPattern` parameter has empty or non-string parameter.
 */
function replaceTextUnsafe(querySelector, textPattern, textReplacement) {
  if (typeof textPattern !== 'string' && textPattern.length === 0) {
    throw new Error('The parameter `textPattern` of `replaceTextUnsafe` must be a non-empty string.');
  }

  const domElements = document.querySelectorAll(querySelector);

  if (!domElements) return;

  domElements.forEach((domElement) => {
    domElement.innerHTML = domElement.innerHTML.replaceAll(textPattern, textReplacement);
  });
}
